import { graphql } from "react-relay";

export const UpdateCurrentUserMutation = graphql`
  mutation UpdateCurrentUserMutation($input: UpdateCurrentUserInput!) {
    updateCurrentUser(input: $input) {
      displayName
      email
      name
      user {
        displayName
        id
      }
    }
  }
`;
